export enum TFilterType {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
}
